import axiosInstance from '../axiosInstance';

/**
 * Envía la encuesta de satisfacción a todos los pasajeros de un manifiesto.
 * El backend se encarga de:
 *   1. Verificar que el manifiesto esté COMPLETADO.
 *   2. Verificar que no se haya enviado antes (idempotencia).
 *   3. Construir y enviar la plantilla por WhatsApp a cada pasajero.
 *
 * @param {number} manId - ID del manifiesto.
 * @returns {Promise<{sent: number, failed: number, total: number, errors?: Array}>}
 */
export const notifySatisfactionSurvey = async (manId) => {
    const { data } = await axiosInstance.post(
        `/administration/surveys/manifests/${manId}/notify`
    );
    return data.data;
};

/**
 * Consulta el estado del envío de la encuesta para un manifiesto.
 * Útil para saber si ya se envió, cuándo, y a cuántos pasajeros.
 *
 * @param {number} manId - ID del manifiesto.
 * @returns {Promise<{sent: boolean, sentAt: string|null, sentCount: number, totalCount: number}>}
 */
export const getSurveyStatus = async (manId) => {
    const { data } = await axiosInstance.get(
        `/administration/surveys/manifests/${manId}/status`
    );
    return data.data;
};

/**
 * Consulta el estado de la encuesta para un pasajero específico.
 * @param {number} manId
 * @param {number} perId
 */
export const getSurveyStatusForPassenger = async (manId, perId) => {
    const { data } = await axiosInstance.get(
        `/administration/surveys/manifests/${manId}/passengers/${perId}/status`
    );
    return data.data;
};

/**
 * Reintenta el envío de la encuesta a un pasajero específico.
 * @param {number} manId
 * @param {number} perId
 */
export const retrySurveyForPassenger = async (manId, perId) => {
    const { data } = await axiosInstance.post(
        `/administration/surveys/manifests/${manId}/notify/retry`,
        { perId }
    );
    return data.data;
};

/**
 * (Opcional) Reintenta el envío de la encuesta a los pasajeros que fallaron.
 * Útil cuando un número de teléfono estaba inválido y se corrigió después.
 *
 * @param {number} manId - ID del manifiesto.
 * @returns {Promise<{sent: number, failed: number, total: number}>}
 */
export const retrySurveyNotification = async (manId) => {
    const { data } = await axiosInstance.post(
        `/administration/surveys/manifests/${manId}/notify/retry`
    );
    return data.data;
};